import { ComponentProps } from "react";

interface CloseIconProps extends ComponentProps<"svg"> {
  color?: string;
  width?: number;
  height?: number;
  strokeWidth?: number;
  style?: React.CSSProperties;
}

export default function CloseIcon(props: CloseIconProps) {
  const { color = "currentColor", width = 12, height = 12, strokeWidth = 1, style, ...rest } = props;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 12 12"
      fill="none"
      {...rest}
      style={style}
    >
      <path d="M1 1L10.9994 10.9994" stroke={color} strokeWidth={strokeWidth} strokeLinecap="round" />
      <path d="M11 1L1.00056 10.9994" stroke={color} strokeWidth={strokeWidth} strokeLinecap="round" />
    </svg>
  );
}
